import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type IconProps = Partial<SVGIconProps>;

const ForumsIcon: FC<IconProps> = (props) => (
  <SVGIcon viewBox="0 0 20 20" {...props}>
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.083 15.834h-.417c-3.333 0-5-.833-5-5V6.667c0-3.333 1.667-5 5-5h6.667c3.333 0 5 1.667 5 5v4.167c0 3.333-1.667 5-5 5h-.417c-.258 0-.508.125-.667.333L11 17.834c-.55.733-1.45.733-2 0l-1.25-1.667c-.133-.183-.442-.333-.667-.333z"
        strokeMiterlimit="10"
      />
      <path d="M5.834 6.667h8.333m-8.333 4.166h5" strokeLinecap="round" />
    </svg>
  </SVGIcon>
);

export default ForumsIcon;
